module.exports = __webpack_public_path__ + "img/help1-2-3.3519e4d4.png";